import { SettingLine, Z3KConfigParserError, Z3KConfigSettingNumber, Z3KConfigSettingTypes, } from '../utils/types';
import { getValue } from '../utils/parser-utils';
import { decodeArguments, encodeArguments } from 'z3k-parser/parser/utils/object-line';
function getParams(line) {
    return line.value.split(' ');
}
export function decodeLogin(line) {
    if (line == null) {
        throw new Z3KConfigParserError('Login Undefined');
    }
    const params = getParams(line);
    return params[0];
}
export function encodeLogin(login, password) {
    return new SettingLine(Z3KConfigSettingTypes.login, login + ' ' + password);
}
export function decodeTimeZone(line) {
    if (line == null) {
        throw new Z3KConfigParserError('Time Zone Undefined');
    }
    return Number(line.value);
}
export function encodeTimezone(timezone) {
    return new SettingLine(Z3KConfigSettingTypes.timezone, `${timezone}`);
}
export function decodeUsbPassword(line) {
    if (line == undefined) {
        return undefined;
    }
    return line.value;
}
export function encodeLocalSubnetName(net) {
    return new SettingLine(Z3KConfigSettingNumber.local_subnet_name, net);
}
export function encodeMqttAddress(net) {
    return new SettingLine(Z3KConfigSettingNumber.mqtt_address, net);
}
export function decodeLocalSubnetName(line) {
    if (line == undefined) {
        return undefined;
    }
    return line.value;
}
export function decodeMqttAddress(line) {
    if (line == undefined) {
        return undefined;
    }
    return line.value;
}
export function decodeOptionalInfo(line) {
    if (line == undefined) {
        return undefined;
    }
    const params = getParams(line);
    let info = {};
    for (const param of params) {
        const [key, value] = param.split(':');
        info = { ...info, [key]: value };
    }
    return info;
}
export function encodeUsbPassword(usb_password) {
    return new SettingLine(Z3KConfigSettingTypes.usb_password, usb_password);
}
export function decodeUseReserveBattery(line) {
    if (line == undefined) {
        return undefined;
    }
    const params = decodeArguments(line.value);
    return params[0] === 1;
}
export function encodeUseReserveBattery(battery) {
    return new SettingLine(Z3KConfigSettingTypes.use_reserve_battery, battery ? '1' : '0');
}
export function decodeServers(line) {
    if (line == undefined) {
        return undefined;
    }
    return line.value;
}
export function encodeServers(servers) {
    return new SettingLine(Z3KConfigSettingTypes.servers, servers);
}
export function decodePort(line) {
    if (line == undefined) {
        return 52200;
    }
    return Number(line.value);
}
export function encodePort(port) {
    return new SettingLine(Z3KConfigSettingTypes.port, `${port}`);
}
export function decodePassword(line) {
    if (line == undefined) {
        return undefined;
    }
    const params = getParams(line);
    return params[1];
}
export function decodeAPN(line) {
    if (line == undefined) {
        return undefined;
    }
    return line.value;
}
export function encodeAPN(apn) {
    return new SettingLine(Z3KConfigSettingTypes.apn, apn);
}
export function decodeA300Interface(line) {
    if (line == undefined) {
        return undefined;
    }
    return Number(line.value);
}
export function encodeA300Interface(diagInterface) {
    return new SettingLine(Z3KConfigSettingTypes.a300_diag_interface, `${diagInterface}`);
}
export function decodeA300Params(line) {
    if (line == undefined) {
        return undefined;
    }
    return Number(line.value);
}
export function encodeA300Params(params) {
    return new SettingLine(Z3KConfigSettingTypes.a300_diag_available_params, `${params}`);
}
export function decodeS7(line) {
    if (line == null) {
        throw new Z3KConfigParserError('Device Info Undefined');
    }
    const params = getParams(line);
    return {
        name: params[0],
        hardware: params[1],
        firmware: params[2],
    };
}
export function encodeDeviceInfo(deviceInfo) {
    return new SettingLine(Z3KConfigSettingTypes.device, `${deviceInfo.name} ${deviceInfo.hardware} ${deviceInfo.firmware}`);
}
export function decodeServiceContact(line) {
    if (line == undefined) {
        return undefined;
    }
    const params = getParams(line);
    const intDate = Number(params[1]);
    const date = intDate === 0
        ? null
        : {
            year: 2000 + (intDate >> 9),
            month: (intDate >> 5) & 0xf,
            day: intDate & 0x1f,
        };
    return {
        phone: params[0],
        date: date,
    };
}
export function encodeServiceContact(serviceContact) {
    const intDate = serviceContact.date !== null
        ? ((serviceContact.date.year - 2000) << 9) |
            (serviceContact.date.month << 5) |
            serviceContact.date.day
        : 0;
    return new SettingLine(Z3KConfigSettingTypes.service_contact, `${serviceContact.phone} ${intDate}`);
}
export function decodeGSM(line1, line2) {
    if (line1 == undefined) {
        return undefined;
    }
    const params = getParams(line1);
    return {
        ussd: params[0],
        threshold: Number(params[1]),
        notification: Number(line2?.value) === 0 ? null : Number(line2?.value),
    };
}
export function encodeGsmSettings(GsmSettings) {
    return new SettingLine(Z3KConfigSettingTypes.gsm_settings, `${GsmSettings.ussd} ${GsmSettings.threshold}`);
}
export function encodeGsmSettingsNotification(notification) {
    return new SettingLine(Z3KConfigSettingTypes.gsm_settings_notification, `${notification}`);
}
export function decodeServerSetting(line) {
    if (line == undefined) {
        return undefined;
    }
    const params = decodeArguments(line.value);
    const flags = getValue(params, 0, 0);
    return {
        show_control_devices_state: (flags & 0x01) != 0,
    };
}
export function decodeWiFi(line) {
    if (line == undefined) {
        return undefined;
    }
    const params = decodeArguments(line.value);
    return {
        netname: params[0],
        pass: params[1],
        //@ts-ignore
        is_enabled: params[2] > 0,
    };
}
export function decodeWiFiAccessPoint(line) {
    if (line == undefined) {
        return undefined;
    }
    const params = decodeArguments(line.value);
    return {
        ssid: params[0],
        password: params[1],
    };
}
export function encodeWifiSettings(wifiSettings) {
    return new SettingLine(Z3KConfigSettingTypes.wifi_settings, encodeArguments([
        wifiSettings.netname,
        wifiSettings.pass,
        wifiSettings.is_enabled ? 1 : 0,
    ]));
}
export function encodeWifiAccessPoint(wifiAccessPoint) {
    return new SettingLine(Z3KConfigSettingTypes.wifi_access_point, encodeArguments([wifiAccessPoint.ssid, wifiAccessPoint.password]));
}
export function decodePort485(line) {
    if (line == undefined) {
        return undefined;
    }
    const params = decodeArguments(line.value);
    return {
        setting_register: Number(params[0]),
        speed: Number(params[1]),
        stop_byte_count: Number(params[2]),
        parity_check: Number(params[3]),
    };
}
export function encodePortRS485(port) {
    return new SettingLine(Z3KConfigSettingTypes.port_rs485, `${port.setting_register},${port.speed},${port.stop_byte_count},${port.parity_check}`);
}
export function encodeServerSettings(serverSettings) {
    let flag = 0;
    if (serverSettings.show_control_devices_state) {
        flag |= 0x01;
    }
    return new SettingLine(Z3KConfigSettingTypes.server_settings, encodeArguments([flag]));
}
export function decodeStockConfig(line) {
    if (line == undefined)
        return undefined;
    const params = decodeArguments(line.value);
    if (params.length >= 3) {
        return {
            id: params[0] ?? null,
            title: params[1] ?? null,
            version: params[2] ?? null,
        };
    }
    return undefined;
}
export function encodeStockConfig(stockconfig) {
    if (stockconfig.id !== null) {
        return new SettingLine(Z3KConfigSettingTypes.stock_config, encodeArguments([
            stockconfig.id ? stockconfig.id : '',
            stockconfig.title ? stockconfig.title.slice(0, 200) : [],
            stockconfig.version ? stockconfig.version : '',
        ]));
    }
    else {
        return new SettingLine(211, '');
    }
}
